import apiClient from './client';
import { CompanyFiscalProfileDto, CompanyFiscalProfileUpdateRequestDto } from 'interfaces/invoicing';
import { invoicingRequest } from './invoicingErrors';

type CompanyId = number | string;

interface FiscalProfileService {
  get(companyId: CompanyId): Promise<CompanyFiscalProfileDto>;
  update(companyId: CompanyId, data: CompanyFiscalProfileUpdateRequestDto): Promise<CompanyFiscalProfileDto>;
}

const endpoints = {
  fiscalProfile: (companyId: CompanyId) => `/tenant/companies/${companyId}/invoicing/fiscal-profile`,
};

const REDACTED = '[REDACTED]';

interface RequestConfigLike {
  data?: unknown;
}

const redactConfig = (config?: RequestConfigLike) => {
  if (typeof config?.data !== 'string' || !config.data.includes('aadeSubscriptionKey')) return;
  try {
    const body = JSON.parse(config.data);
    config.data = JSON.stringify({ ...body, aadeSubscriptionKey: REDACTED });
  } catch {
    config.data = REDACTED;
  }
};

/**
 * A request that fails without an envelope error (timeout, network) is rethrown as the raw axios
 * error, whose request config still holds the body. The subscription key is write-only, so it is
 * masked there before the error reaches any logging or error reporting.
 */
export const redactSubscriptionKey = (error: unknown): unknown => {
  const httpError = error as { config?: RequestConfigLike; response?: { config?: RequestConfigLike } } | undefined;
  redactConfig(httpError?.config);
  redactConfig(httpError?.response?.config);
  return error;
};

export const fiscalProfileService: FiscalProfileService = {
  get: companyId => invoicingRequest(() => apiClient.get(endpoints.fiscalProfile(companyId))),
  update: (companyId, data) =>
    invoicingRequest<CompanyFiscalProfileDto>(() => apiClient.put(endpoints.fiscalProfile(companyId), data)).catch(error => {
      throw redactSubscriptionKey(error);
    }),
};
